import RequestIndex from "@/api/index";
import request from "@/common/request";
import { IGraphicPageRes, IHot, ICommentRes } from "./types";
class Request extends RequestIndex {
  /**
   * 图文详情
   * @param infoClassifyId 新闻id
   */
  getInfoDetailNew(infoClassifyId: string): Promise<IGraphicPageRes> {
    return request.post("/infoDetailNew.html", {
      infoClassifyId
    });
  }

  /**
   * 获取热点新闻
   */
  getHotList(id: string): Promise<IHot> {
    return request.post("/getCorrelation.html", {
      id,
      appId: this.appId
    });
  }

  /** 评论列表 分页 */
  getCommentListByPage(
    sourceId: string,
    sourceType: string | number,
    lastCreateTime: string,
    lastReplyId: number | undefined,
    token?: string | number
  ): Promise<ICommentRes> {
    return request.post(process.env.VUE_APP_BASEGATE_API + "/comments", {
      appId: this.appId,
      sessionId: this.sessionId,
      token: this.token,
      sourceId,
      sourceType,
      lastCreateTime,
      lastReplyId
    });
  }
}
export default new Request();
